import { useDispatch, useSelector } from "react-redux";
import { useParams  } from "react-router";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Box, Grid } from "@mui/material";
import FormikControl from "../../bmr/components/common/FormikControl";
import { LoadingButton } from "@mui/lab";
import { markedAsDispatched } from "../../bmr/slices/common";
import { fetchAllActiveDeliveryPartners, selectDeliveryActivePartnersAll } from "../../bmr/slices/deliveryPartners";
import React, { useEffect } from 'react';

const initialValues = {
  delivery_partner_id: "",
  awb_number: "",
};

const validationSchema = Yup.object().shape({
  delivery_partner_id: Yup.string().required("Delivery Partner is required"),
  awb_number: Yup.string()
    .required("AWB Number is required")
    .max(150, "Maximum of 150 characters"),
  tracking_link: Yup.string()
    .url("Tracking Link must be a valid URL")
    .nullable()
    .notRequired()
    .test(
      "is-empty-or-valid-url",
      "Tracking Link must be a valid URL",
      (value) => !value || Yup.string().url().isValidSync(value)
    ),
});



const MarkedAsDispatched = ({ handleFormSubmit = () => { }, feasibility_id, }) => {
  const dispatch = useDispatch();
  const { subjectId } = useParams();
  const deliveryPartnerOptions = useSelector(selectDeliveryActivePartnersAll) || []


  useEffect(() => {
    const fetchAll = async () => {
        await dispatch(fetchAllActiveDeliveryPartners())
    };
    fetchAll();
  }, [dispatch]);


const formOptions = [
  {
    type: "select",
    label: "Delivery Partner",
    name: "delivery_partner_id",
    options: deliveryPartnerOptions,
    required: true,
    placeholder: "Select partner",
  },
  {
    label: "AWB Number",
    type: "text",
    name: "awb_number",
    required: true,
    placeholder: "Enter AWB number",
  },
  {
    label: "Tracking Link",
    type: "text",
    name: "tracking_link",
    required: false,
    placeholder: "Enter Tracking Link",
  },
];

  const handleSubmit = async (values) => {
    try {
      const res = await dispatch(markedAsDispatched({
        patient_id: subjectId,
        feasibility_id: feasibility_id,
        data: { ...values },
      })
      ).unwrap();
      if (res.status === 200) {
        handleFormSubmit();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className="mb-3">
          {formOptions.map((props, key) => (
            <Grid key={key} item xs={12}>
              <FormikControl formik={formik} {...props} />
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LoadingButton fullWidth type="submit" variant="contained">
              Submit
            </LoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default MarkedAsDispatched;
